module.exports = __webpack_public_path__ + "img/midstart.ecb4dc7f.png";